module.exports = __webpack_public_path__ + "img/ava-banner.28039287.jpg";